import { render, staticRenderFns } from "./ButtonShow.vue?vue&type=template&id=9c025054&scoped=true&"
import script from "./ButtonShow.vue?vue&type=script&lang=js&"
export * from "./ButtonShow.vue?vue&type=script&lang=js&"
import style0 from "./ButtonShow.vue?vue&type=style&index=0&id=9c025054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c025054",
  null
  
)

export default component.exports